import { pluralize } from '@/utils/helpers'

import { MAX_SAT_BOOTCAMP_SESSION_RESCHEDULES_ALLOWED } from '@/client/services/satBootcamp'
import { getArticleUrl } from '@/client/services/url/faq'

import ShwLink from '@/components/ShwLink'
import Alert from '@/components/UI/Alert'

export default function SATBootcampRescheduleAlert({
  countReschedules,
}: {
  countReschedules: number
}): JSX.Element {
  const difference = Math.max(MAX_SAT_BOOTCAMP_SESSION_RESCHEDULES_ALLOWED - countReschedules, 0)

  return difference <= 0 ? (
    <Alert variant="warning">
      You have reached the maximum number of reschedules per bootcamp. Please read{' '}
      <ShwLink href={getArticleUrl('sat-bootcamp-reschedule')}>this FAQ</ShwLink> for next steps.
    </Alert>
  ) : (
    <Alert variant="warning">
      After learner registration starts, you are allowed up to{' '}
      {pluralize(MAX_SAT_BOOTCAMP_SESSION_RESCHEDULES_ALLOWED, 'reschedule')} per bootcamp (
      {difference} remaining). Please read{' '}
      <ShwLink href={getArticleUrl('sat-bootcamp-reschedule')}>this FAQ</ShwLink> for more info.
    </Alert>
  )
}
